import Vue from 'vue';
import { queryUser } from "@/api/users.js";

const state = () => ({
    infoDetail: {
        logoutLink: '',
        portalIndexLink: '',
        loginLink: '',
    },
    user:{

    },
    firstTime: false,
    surveyRequired :false,
    hasSurvey: false,
    errorCookie: false,  //觸發無權限或者權限過期時
    langIsSelected : {},
});

// getters
const getters = {
    getLogoutLink: function (state) {
        return state.infoDetail.logoutLink
    },
    getLoginLink: function (state) {
        return state.infoDetail.portalIndexLink
    },
    getIsSurveyRequired: function (state) {
        return state.surveyRequired
    },
    
};

// actions
const actions = {
    async getUserInfo({ commit, dispatch, state }) { //no use
        try{
            const {data } = await queryUser();
            if(data){
                commit("setUserInfo", data);
                commit("setUserFirst", data.info.agree);
            }
            
        } catch(error){
            // const _location = window.location;
            // const _path = 'next=' + encodeURIComponent(_location.pathname + _location.hash)
            // const _currentPageName = this.$route.name;
            // let currentEnv = process.env.VUE_APP_ENV;
            // console.log('_path',_path)
            // if (currentEnv != 'test' && currentEnv != 'mock' ) {
            //     this.goToLogin(_currentPageName, _path)
            // } 
        }
        
    },
};

// mutations
const mutations = {
    setUserInfo(state, data) {
        state.user = data
    },
    setUserFirst(state, data) {
        state.firstTime = data
    },
    setSurveyRequired(state, data) {
        state.surveyRequired = data
    },
    setErrorCookie(state, data) {
        state.errorCookie = data
    },
    setHasSurvey(state, data) {
        state.hasSurvey = data
    },
    setLangIsSelected(state, val) {
        state.langIsSelected = val;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};